import React, { useState } from 'react'
import { FaHandHolding, FaIdCard, FaSchool, FaUserAlt } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, ModalComponent, SelectFieldIcon, Panel, FileFieldIcon, TextFieldIcon } from '../_components'
import { FaBuilding, FaAddressCard, FaHourglassEnd, } from 'react-icons/fa'
import Table from '../_components/Table'
import ApplicationForm from './ApplicationForm'
import { IdleTimeout } from '../_screens'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'

const ActionView = record => {
  return (
    <div className="flex items-center">
      <div onClick={async () => {
        await localStorage.setItem("link", "application_details")
        await localStorage.setItem("applicationId", record.row.original.id)
        return window.location.reload()

      }} className="rounded bg-green-100 border border-gray-200 px-2 py-1 w-1/2 text-center text-gray-500 cursor-pointer">
        {`View`}
      </div>
    </div>

  )
}

const ProgressField = record => {
  return (
    <div className="flex w-full items-center justify-center">
      <ProgressBar value={record.value || 0} />
      <div className="text-xs mx-2">
        {`${record.value}%`}
      </div>
    </div>
  )
}

const handleIdle = () => {
  localStorage.clear();
  // Perform any other actions you need when the application is idle.
  return window.location.reload()
};

export default function Welcome() {

  const [records, setRecords] = React.useState([])
  const [showRenewCertificateModal, setShowRenewCertificateModal] = useState(false)
  const [circularLoading, setCircularLoading] = React.useState(false)
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [files, setFiles] = useState([])
  const [ serviceNames, setServiceNames ] = useState( [{ service_name: "" }] )
  const [ skillNames, setSkillNames ] = useState( [{ service_name: "" }] )
  const [ servicesDropdown, setServicesDropdown ] = useState( [] )
  const [ skillsDropdown, setSkillsDropdown ] = useState( [] )

  const toggleFileSelection = (id) => {
    setSelectedFiles(prev =>
      prev.includes(id) ? prev.filter(fileId => fileId !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    if (selectedFiles.length === files.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(files.map(file => file.id));
    }
  };

  const fetchAllDocuments = async (applicationId) => {
    try {
      await localStorage.setItem("applicationId", applicationId)
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getApplicationFiles/` + applicationId);
      if (response.data) {
        setFiles(response.data?.data);
      }
    } catch (error) {
      console.error("Error fetching documents: ", error);
    }
  };

  const fetchIsicCodes = async (evt) => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_isic_codes`);
      const et_response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_et_isic_codes`);

      if (localStorage.getItem( "domain" ) === "ET") {
        if( et_response.data.message === "success" ) {
          let isicCodes = et_response.data.db_records
          let isicDbCodes = isicCodes.map((item) => {
            return {
              id: item.id,
              label: `${item.class}: ${item.description}`,
              value: item.class
            }
          }
          );
          setServicesDropdown(isicDbCodes)
        } else{
          console.log("response returned error")
        }
      } else {
        if( response.data.message === "success" ) {
          let isicCodes = response.data.db_records
          let isicDbCodes = isicCodes.map((item) => {
            return {
              id: item.id,
              label: `${item.class}: ${item.description}`,
              value: item.class
            }
          }
          );
          setServicesDropdown(isicDbCodes)
        } else{
          console.log("response returned error")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSkillsCodes = async (evt) => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/get_skills_codes`);

      if( response.data.message === "success" ) {
        let skillCodes = response.data.db_records
        let skillDbCodes = skillCodes.map((item) => {
          return {
            id: item.id,
            label: `${item.skill_code}: ${item.skill}`,
            value: item.skill_code
          }
        }
        );
        setSkillsDropdown(skillDbCodes)
      } else{
        console.log("response returned error")
      }
    } catch (error) {
      console.log(error)
    }
  }

  const EditView = record => {
    // console.log("record ===> "+record.row.original.stage)
    return (
      <>
        {(record.row.original.stage === "1" || record.row.original.stage === null) &&
          <div className="flex items-center">
            <div onClick={async () => {
              await localStorage.setItem("edit_set", "true")
              await localStorage.setItem("applicationId", record.row.original.id)
              setForm(true)

            }} className="rounded bg-blue-200 border border-gray-200 px-2 py-1 w-3/4 text-center text-gray-500 cursor-pointer">
              {`Edit`}
            </div>
          </div>
        }
        <IdleTimeout timeout={600000} onIdle={handleIdle} />
      </>
    )
  }

  const DocumentsView = record => {
    // console.log("record ===> "+record.row.original.stage)
    return (
      <>
        {(record.row.original.stage < 2) &&
          <div className="flex items-center">
            <div onClick={async () => {
              await localStorage.setItem("link", "add_client_document")
              await localStorage.setItem("applicationId", record.row.original.id)
              return window.location.reload()
            }} className="rounded bg-amber-600 border px-2 py-1 w-3/4 text-center text-white cursor-pointer">
              {`Documents`}
            </div>
          </div>
        }
        <IdleTimeout timeout={600000} onIdle={handleIdle} />
      </>
    )
  }

  const RenewCertificate = record => {
    const { certificate_expiry_date, stage } = record.row.original;

    if (!certificate_expiry_date) return null; // 👈 hide if not present

    return (
      <>
        {stage > 1 && (
          <div className="flex items-center">
            <div
              onClick={async () => {
                setShowRenewCertificateModal(true)
                await localStorage.setItem("applicationName", record.row.original.trading_name)
                fetchAllDocuments(record.row.original.id);
              }}
              className="rounded bg-green-600 border px-2 py-1 w-3/4 text-center text-white cursor-pointer"
            >
              {`Renew Certificate`}
            </div>
          </div>
        )}
        <IdleTimeout timeout={600000} onIdle={handleIdle} />
      </>
    );
  }

  const defaultColumns = React.useMemo(() => {
    const baseCols = [
      { Header: "#", accessor: "recordId" },
      { Header: "Business /Trading Name", accessor: "trading_name" },
      { Header: "Date Applied", accessor: "date_applied" },
      { Header: "Progress", accessor: "progress", Cell: ProgressField },
      { Header: "Application Details", accessor: "id", Cell: ActionView },
      { Header: "Edit", accessor: "edit", Cell: EditView },
      { Header: "Documents", accessor: "add_documents", Cell: DocumentsView },
    ];

    // Only add this column if at least one record has certificate_expiry_date
    if (records.some(r => r.certificate_expiry_date)) {
      baseCols.push({
        Header: "Renew Certificate",
        accessor: "renew_certification",
        Cell: RenewCertificate
      });
    }

    return baseCols;
  }, [records]);

  const [form, setForm] = React.useState(false)
  const [signing, setSigning] = React.useState(false)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    if (loading) {
      fetchApplications()
      fetchIsicCodes()
      fetchSkillsCodes()
    }
  }, [loading])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcoapplication`)
      if (response.data) {
        const results = response.data.map((val, index) => {
          return {
            recordId: `${index + 1}`,
            id: val.id,
            trading_name: val.trading_name,
            date_applied: moment(val.created_at).format("DD MMM, YYYY"),
            turnover: val.annual_turnover,
            created_by: val.created_by,
            progress: val.progress,
            stage: val.stage,
            certificate_expiry_date: val.certificate_expiry_date,
            edit: val.id
          }
        }).filter(result => {
          return result.created_by === localStorage.getItem("email")
        })
        //console.log(results)

        setRecords(results)
        setLoading(false)
      }
      setLoading(false)
    } catch (error) {
      alert("Server error occured.")
      setLoading(false)
    }
  }

  const deleteSelectedFiles = async () => {
    if (!window.confirm("Are you sure you want to delete the selected files?")) return;

    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/delete_multiple_documents`, {
        file_ids: selectedFiles
      });

      if (response.data) {
        alert(response.data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      alert("Failed to delete selected files.");
    }
  };

  const previewFile = async (e) => {
    let file_id = e.target.id

    try {
      const email = btoa(localStorage.getItem("email")); // Base64 encode
      const url = process.env.REACT_APP_API_URL + `/api/auth/get_file_details/${file_id}/${email}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) { }
  }

  const DeleteFile = async (e) => {
    let file_id = e.target.id

    if (window.confirm("Are you sure you want to delete this file ?") == true) {
      try {
        const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/delete_application_document`, { file_id: file_id })
        if (response.data) {
          alert(response.data.message)
          return window.location.reload()
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const fileConversionTo64String = async (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result.split(',')[1]); // Extract base64 string
    };
    reader.onerror = (error) => {
      console.error("Error converting file to base64:", error);
    };
    reader.readAsDataURL(file);
  };

  const handleApplicationForRenewal = async (values) => {
    setCircularLoading(true);

    try {
      const data = new FormData();
      data.append("application_id", localStorage.getItem("applicationId"));

      for (const file of values.files || []) {
        if (file.document) {
          const base64String = await new Promise((resolve, reject) => {
            fileConversionTo64String(file.document, resolve);
          });
      
          data.append("file[]", base64String); // Append to "file[]" as base64 string
          data.append("name[]", file.name || file.title || "Document");
          data.append("title[]", file.name || file.title || "Document");
          data.append("type[]", file.type || file.document.type);
          data.append("size[]", file.size || file.document.size);
          data.append("description[]", file.description || file.tag || "");
          data.append("created_by[]", localStorage.getItem("email"));
        }
      }
      
      serviceNames.forEach(service => {
        if (service.service_name) {
          data.append("service_name[]", service.service_name);
        }
      });

      data.append("certification_level", values.certification_level);
      data.append("user_email", localStorage.getItem("email"));
      data.append("renewal_process", true);

      const response = await Axios.post(
        process.env.REACT_APP_API_URL + `/api/auth/addITDocuments`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data) {
        alert(response.data.message);
        setShowRenewCertificateModal(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error in processing renewal:", error);
      alert("Failed to process the renewal. Contact NITA-U Staff for assistance.");
    } finally {
      setCircularLoading(false);
    }
  };


  return (
    <Wrapper>
      <div className="flex flex-col h-full">
        {(localStorage.getItem("role") === "ADMIN" && <BarStrip />)}
        {!form ? (
          <div className="flex-grow flex flex-col bg-gray-100 my-2">
            <div className="h-12 w-full p-2 md:py-3 lg:py-3 lg:px-8 md:px-8 lg:my-5">
              <h2 className="text-gray-500 text-2xl font-bold">
                {`Welcome Back, ${localStorage.getItem("username")}`}
              </h2>
            </div>
            {localStorage.getItem("role") === "ADMIN" ?
              (<div className="grid grid-cols-1 px-2 md:grid-cols-2 md:gap-3 md:px-8 lg:px-8">
                <CardPanel icon={<FaHandHolding size={32} color={`#AFC836`} />} label="I.T Service Providers" />
                <CardPanel icon={<FaSchool size={32} color={`#AFC836`} />} label="I.T Training Institutions" />
                <CardPanel icon={<FaIdCard size={32} color={`#AFC836`} />} label="E-Transactions" />
                <CardPanel icon={<FaUserAlt size={32} color={`#AFC836`} />} label="Individual I.T Service Providers" />
              </div>) : (
                <div className="flex-grow flex flex-col bg-gray-100 my-2 px-3">
                  <div className="flex items-center justify-between bg-white py-2">
                    <div className="px-5 py-2 text-sm font-bold">
                      {`Your Recent Applications`}
                    </div>
                    <div>
                      <button onClick={() => setForm(!form)} type="button" className="rounded px-2 text-xs bg-green-700 flex items-center justify-center p-2 text-white">
                        {`Make New Application`}
                      </button>
                    </div>
                  </div>
                  <div className="flex w-full bg-white">
                    {records.length > 0 ? (
                      <Table
                        rightButtonLabel={null}
                        label="Latest Applications"
                        columns={defaultColumns}
                        data={records}
                        hidePagination={false}
                      />) : (
                      <div className="w-full flex items-center justify-center text-center text-xs md:text-base lg:text-base">
                        {`You have not made any New Applications`}
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>) : (
          <>
            <div className="flex items-center justify-between px-2">
              <div className="p-5 text-xs md:text-base lg:text-base font-bold">
                {`Make A New Application - IT Service Provider`}
              </div>
              <div>
                <button onClick={() => setForm(!form)} type="button" className="rounded px-2 text-xs bg-green-700 flex items-center justify-center p-2 text-white">
                  {`View Latest Applications`}
                </button>
              </div>
            </div>
            <div className="flex-grow flex flex-col bg-gray-100 my-1 px-5">
              <ApplicationForm />
            </div>
          </>
        )}
      </div>

      <ModalComponent className='text-blue-500' title={`Renew certificate for: ` + localStorage.getItem("applicationName")} open={showRenewCertificateModal}>
        <Panel label="Below are your existing documents. Select the ones you want to delete or upload new ones.">
          <table className="w-full border">
            <thead className="text-xs bg-gray-200 font-bold p-2">
              <th className="p-2">#</th>
              <th>Name</th>
              <th>Size</th>
              <th>Action</th>
              <th className="p-2">
                <input type="checkbox" onChange={toggleSelectAll} />
              </th>
              <th>Date Created</th>
            </thead>
            <tbody>
              {files?.map((item, index) => {
                return (
                  <tr className="text-xs p-2 text-center">
                    <td className="p-2">{`${index + 1}`}</td>
                    <td>{item.name}</td>
                    <td>{item.size}</td>
                    <td>
                      <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={previewFile}>View File</a>
                      <a className="bg-red-800 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={DeleteFile}>Delete</a>
                    </td>
                    <td className="p-2">
                      <input
                        type="checkbox"
                        checked={selectedFiles.includes(item.id)}
                        onChange={() => toggleFileSelection(item.id)}
                      />
                    </td>
                    <td>{moment(item.created_at).format("DD MMM, YYYY HH:mm:ss")}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <div className="flex justify-between">
            <button
              disabled={selectedFiles.length === 0}
              onClick={deleteSelectedFiles}
              className="cursor-pointer w-auto md:w-48 lg:w-64 py-1 rounded bg-red-800 text-xs text-white flex justify-center"
            >
              Delete Selected Files
            </button>
          </div>
        </Panel>

        <Panel label="Specify the certificate level and upload new documents">
          <div className="flex flex-col items-start justify-center px-5 py-2">
            <Formik initialValues={{
              actioned_by: localStorage.getItem("username")
            }} onSubmit={handleApplicationForRenewal}>
              {({ handleSubmit, handleBlur, handleChange, values, setFieldValue }) => {
                return (
                  <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>
                  <div className="flex flex-col justify-center w-100 bg-white">
                    <SelectFieldIcon
                    name="certification_level"
                    handleChange={evt => {
                      handleChange(evt)
                    }}
                    handleBlur={handleBlur}
                    value={values.certification_level}
                    iconComponent={<FaBuilding color={`#AFC836`} />}
                    label="Certification Level"
                    required={localStorage.getItem("domain") === "ET" ? false : true}
                    disabled={signing}
                    options={[
                      { id: 1, value: "CCL1", label: "Level 1" },
                      { id: 2, value: "CCL2", label: "Level 2" },
                      { id: 3, value: "CCL3", label: "Level 3" },
                      { id: 4, value: "ET", label: "E-Transanctions" },
                    ]}
                    question="Certification level that you're renewing for?" />
                  </div>
                  
                  <div className="flex flex-col justify-center w-100 bg-white">
                    {serviceNames.map((item, idx) => (
                    <div key={idx} className="flex items-center mb-2">
                      <SelectFieldIcon
                      name={`serviceNames[${idx}].service_name`}
                      value={item.service_name}
                      handleChange={(evt) => {
                        const updatedServiceNames = [...serviceNames];
                        updatedServiceNames[idx].service_name = evt.target.value;
                        setServiceNames(updatedServiceNames);
                      }}
                      iconComponent={<FaBuilding color={`#AFC836`} />}
                      label={`Service ISIC Code ${idx + 1}`}
                      required={true}
                      disabled={signing}
                      options={servicesDropdown.map(({ id, label, value }) => ({
                        id,
                        label,
                        value,
                      }))}
                      question="Service ISIC Code"
                      />
                      <div className="ml-2">
                      {idx > 0 && (
                        <button
                        type="button"
                        onClick={() => {
                          const updatedServiceNames = serviceNames.filter((_, index) => index !== idx);
                          setServiceNames(updatedServiceNames);
                        }}
                        className="bg-red-500 text-xs rounded-sm text-white px-2 py-1"
                        >
                        {`Remove`}
                        </button>
                      )}
                      </div>
                    </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    onClick={() => {
                      setServiceNames([...serviceNames, { service_name: "" }]);
                    }}
                    className="text-xs bg-gray-400 text-white px-2 py-1"
                    >
                    {`Add Another Service`}
                  </button>

                  <div className="w-full">
                    {values.files?.map((file, index) => (
                    <div key={index} className="grid grid-cols-2 gap-1 mb-2">
                      <TextFieldIcon
                      name={`files[${index}].description`}
                      handleChange={evt => {
                        handleChange(evt)
                      }}
                      handleBlur={handleBlur}
                      value={file.description}
                      iconComponent={<FaAddressCard color={`#AFC836`} />}
                      label={`File Description ${index + 1}`}
                      required={true}
                      question="File Description" />

                      <FileFieldIcon
                      name={`files[${index}].document`}
                      handleBlur={evt => {
                        handleBlur(evt)
                      }}
                      handleChange={evt => {
                        handleChange(evt)
                        //handleFile(evt, `files[${index}].document`)
                        const file = evt.target.files[0];
                        setFieldValue(`files[${index}].document`, file);
                        setFieldValue(`files[${index}].name`, file.name);
                        setFieldValue(`files[${index}].type`, file.type);
                        setFieldValue(`files[${index}].size`, file.size);
                      }}
                      iconComponent={<FaUserAlt color={`#666`} />}
                      label={`Client Document ${index + 1}`}
                      question="Client Document"
                      required={true}
                      tooltip=""
                      tooltipExplanation="Attach any document that was missed by client E.g Contract, LPO, Certificate etc"
                      />
                    </div>
                    ))}
                    <button
                    type="button"
                    onClick={() => {
                      const newFile = { description: "", document: null };
                      setFieldValue("files", [...(values.files || []), newFile]);
                    }}
                    className="text-xs bg-indigo-300 text-white px-2 py-1 my-2"
                    >
                    {`Add Another Document`}
                    </button>
                  </div>

                  {/* Make buttons horizontal */}
                  <div className="flex flex-row items-center my-2 gap-2 h-8">
                    <button type="submit" className="text-xs lg:w-64 rounded bg-purple-700 text-white px-2 py-1">
                    {`Submit`}
                    </button>
                    <button onClick={async () => {
                    setShowRenewCertificateModal(false)
                    }} className="cursor-pointer w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex justify-center">
                    Close
                    </button>
                  </div>
                  </form>
                )
              }}
            </Formik>
          </div>
        </Panel>
      </ModalComponent>
    </Wrapper>
  )
}

const CardPanel = ({ label, icon }) => {
  return (
    <div className="cursor-pointer flex items-center justify-center items-center h-24 my-2 md:my-0 lg:my-0 md:h-36 lg:h-36 flex rounded-xl bg-[#AFC836] shadow-md">
      <div className="h-28 w-1/4 flex items-center justify-end">
        <div className="rounded-full bg-black h-3/4 w-20 flex items-center justify-center">
          {icon}
        </div>
      </div>
      <div className="flex-grow mx-2">
        <div>
          <span className="text-black font-bold text-sm">{label}</span>
        </div>
      </div>
    </div>
  )
}
